import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { IntelListRoutingModule } from './intel-list-routing.module';
import { IntelListComponent } from './intel-list.component';
import { DisableControlDirective } from './directives/disable-control-directive';
import { PivotFieldsPipe } from './pipes/pivot-fields-pipe';
import { RegulateTagsPipe } from './pipes/regulate-tags.pipe';
import { RuleQueryeditorComponent } from '../rule/code-editor/rule-query-editor.component';
import { CreateIntelListComponent } from '../intel-list/create-intel-list/create-intel-list.component';
import { ImportIntelListComponent } from './create-intel-list/import-intel-list/import-intel-list.component';
import { AggregationRuleComponent } from '../rule/create-rule/aggregation-rule/aggregation-rule.component';
// import { AiRuleComponent } from '../rule/create-rule/ai-rule/ai-rule.component';
// import { BaselineRuleComponent } from '../rule/create-rule/baseline-rule/baseline-rule.component';
// import { ListRuleComponent } from '../rule/create-rule/list-rule/list-rule.component';
import { NewTermRuleComponent } from '../rule/create-rule/new-term-rule/new-term-rule.component';
// import { RatioRuleComponent } from '../rule/create-rule/ratio-rule/ratio-rule.component';
import { RuleTabsComponent } from './rule-tabs/rule-tabs.component';
import { StandardRuleComponent } from '../rule/create-rule/standard-rule/standard-rule.component';
import { StepsizeComponent } from '../rule/create-rule/stepsize/stepsize.component';
import { ThreatIntelComponent } from '../rule/create-rule/threat-intel/threat-intel.component';
// import { TimeRelativeRuleComponent } from '../rule/create-rule/time-relative-rule/time-relative-rule.component';
import { TimeframeComponent } from '../rule/create-rule/timeframe/timeframe.component';
// import { UniqueRuleComponent } from '../rule/create-rule/unique-rule/unique-rule.component';
import { LookBackComponent } from '../rule/lookback/lookback.component';
// import { HostTrigger } from '../rule/lookback/pipes/hosttrigger.pipe';
import { LookbackalertComponent } from '../rule/lookbackalert/lookbackalert.component';
// import { EnableActionPipe } from '../rule/lookbackalert/pipes/enableaction.pipe';
import { AggregateFuctionFieldsDirective } from './directives/aggregate-functionfield-directive';
import { ArrayControlDirective } from './directives/array-control-directive';
import { HostControlDirective } from './directives/lookbackhost-directive';
import { TagHostDirective } from './directives/lookbacktaghost-directive';
import { AggregationErrorMsgCombinePipe } from './pipes/aggregation-errormsg-combine.pipe';
import { ProvideButtonLabelPipe } from './pipes/buttonlabel.pipe';
import { CombineArrayPipe } from './pipes/combinearray.pipe';
import { ExpandedHostGuide } from './pipes/expandedhost-guide.pipe';
import { LimitArray } from './pipes/limit-arrayvalue.pipe';
import { LimitString } from './pipes/limit-string.pipe';
import { OnlyOneError } from './pipes/only-one-error.pipe';
import { PaginationPipe } from './pipes/pagination.pipe';
import { ProvideErrorMessagePipe } from './pipes/provide-error-pipe';
import { OperatorFieldPipe } from './pipes/provide-operator-pipe';
import { RegulateSpecialCharsPipe } from './pipes/regulatespecial-charters.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxEchartsModule } from 'ngx-echarts';
import { SharedModule } from '../shared/shared.module';
import { RuleService } from '../rule/rule-custom-service';
import { RulevarService } from '../rule/rulevar.service';
import { ViewIntelListComponent } from './view-intel-list/view-intel-list.component';
import { EditIntelListComponent } from './view-intel-list/edit-intel-list/edit-intel-list.component';


@NgModule({
  declarations: [
    IntelListComponent,
    DisableControlDirective,
    PivotFieldsPipe,
    RegulateTagsPipe,
    OnlyOneError,
    LimitString,
    LimitArray,
    ArrayControlDirective,
    RegulateSpecialCharsPipe,
    // LimitSetPipe,
    ProvideButtonLabelPipe,
    AggregationErrorMsgCombinePipe,
    ProvideErrorMessagePipe,
    RuleTabsComponent,
    AggregateFuctionFieldsDirective,
    ExpandedHostGuide,
    TagHostDirective,
    // HostTrigger,
    HostControlDirective,
    // EnableActionPipe,
    CombineArrayPipe,
    PaginationPipe,
    // RuleQueryeditorComponent,
    // StandardRuleComponent,
    // TimeframeComponent,
    // StepsizeComponent,
    // NewTermRuleComponent,
    // ListRuleComponent,
    // AggregationRuleComponent,
    // RatioRuleComponent,
    // BaselineRuleComponent,
    // UniqueRuleComponent,
    // AiRuleComponent,
    // TimeRelativeRuleComponent,
    // ThreatIntelComponent,
    OperatorFieldPipe,
    CreateIntelListComponent,
    ImportIntelListComponent,
    ViewIntelListComponent,
    EditIntelListComponent,
  ],
  providers: [RuleService, RulevarService,DatePipe],
  imports: [
    CommonModule,
    IntelListRoutingModule,
    SharedModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') })
  ]
})
export class IntelListModule { }
